import alt from "../alt";

class BoxOfficeActions {
  constructor() {
    this.generateActions(
      "reset",
      "updateCurrentOrder",
      "submitOrder",
      "initializeTerminal",
      "terminalUnexpectedDisconnect",
      "terminalConnectionStatusChange",
      "terminalPaymentStatusChange",
      "cancelExternal",

      "setDisplayMode",
      "updatePosConfig"
    );
  }
}

export default alt.createActions(BoxOfficeActions);



// WEBPACK FOOTER //
// ./src/app/actions/BoxOfficeActions.js